export enum CryptotokenListColId {
  tokenName = 'tokenName',
  active = 'active',
  autoActivation = 'autoActivation',
  actions = 'actions',
}
